/**
 * Declaration of Non-Beneficial Owner (M32110) mapper.
 */
import type { SignerEntry } from '@/features/AI-documents/types/docGen.types';
import { formatMyAddressLine } from '@/shared/utils/malaysianAddress';
import { typeOf } from '../components/declarationNonBo/declarationNonBoFields';

export interface DeclarationNonBoState {
  values: Record<string, string>;
  /** [[Signers]] — Member 선언자 */
  signers: Record<string, SignerEntry[]>;
}

export function emptyDeclarationNonBoState(): DeclarationNonBoState {
  return {
    values: {},
    signers: {},
  };
}

export function buildDeclarationNonBoVariables(state: DeclarationNonBoState): Record<string, any> {
  const out: Record<string, any> = {};
  for (const [k, v] of Object.entries(state.values || {})) {
    const raw = v ?? '';
    out[k] = typeOf(k) === 'address' ? formatMyAddressLine(String(raw)) : raw;
  }
  return out;
}
